module.exports = __webpack_public_path__ + "static/media/18a.1a2dddeb.jpg";